import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { ErrorResponse } from '@shared/models/error.model';
import { ChangePasswordService } from '@shared/services/change-password.service';
import { NGXLogger } from 'ngx-logger';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { ChangePasswordResponse } from '../../models/force-change-password.model';
import {
  ChangePasswordFailed,
  ChangePasswordRequestAction,
  ChangePasswordSuccess,
  UserActionTypes
} from '../actions/user-info.action';

@Injectable()
export class ChangePasswordEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly logger: NGXLogger,
    private readonly changePasswordService: ChangePasswordService
  ) {}

  forceChangePassword$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType<ChangePasswordRequestAction>(UserActionTypes.CHANGE_PASSWORD_REQUEST),
      map((action: ChangePasswordRequestAction) => action.payload),
      switchMap((changePasswordRequest) => {
        return this.changePasswordService.forceChangePassword(changePasswordRequest).pipe(
          map((changedPassword: HttpResponse<ChangePasswordResponse>) => {
            return new ChangePasswordSuccess({
              statusCode: changedPassword.status.toString(),
              message: changedPassword.statusText
            });
          }),
          catchError((err) => {
            if (err && err.status === 401) {
              err = {
                error: this.mapErrorCodeSessionExpired()
              };
            }
            return of(new ChangePasswordFailed(err.error));
          })
        );
      })
    );
  });

  checkErrorCode(errorCode: string) {
    return ['02008', '02010', '02006', '02003'].includes(errorCode);
  }

  mapErrorCodeSessionExpired(): ErrorResponse {
    return {
      code: '01008',
      message: 'Your session is expired, please re-proceed again.',
      translateKey: 'ERROR_CODE.01008'
    };
  }

  private stringify(data: any) {
    return JSON.stringify(data);
  }
}
